import React from 'react';
import server from '../server'
import Employee from './Employee'
import NewSecretaryForm from '../forms/NewSecretaryForm';
import NewDoctorForm from '../forms/NewDoctorForm';
import Alert from "../global/Alert";

const styles = {
    modal:{
        position: "absolute",
        width:"auto",
        height:"auto",
        top: "50%",
        left: "50%",
    },

    paper:{
        position: "absolute",
        padding:30,
        width:300,
        textAlign: "center",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)"
    }
}

class ClinicEmployees extends React.Component{
    state={
        employees: [],
        modal:false
    }

    componentWillMount(){
        this.load_employees();
    }

    load_employees= () =>{
        const clinic = JSON.parse(localStorage.getItem('clinic'))

        server.get("clinics/" +clinic.id + "/employees", (data => {
            let content = [];
            for(let employee in data){
                content.push(<Employee data={data[employee]}/>);
            }
            this.setState({employees: content});
            this.props.updateEmployees(content.length);
        }))
    }

    refresh =()=>{
        this.load_employees();
        this.setState({open:true,modal:false,message:"Empregado cadastrado com sucesso!"},this.forceUpdate)
        this.props.refreshed();
    }

    render(){
        if(this.props.shouldRefresh) this.refresh();

        return(
            <div>
                <div container>
                    <div item xs={12}>
                        {this.state.employees}
                    </div>
                </div>
            </div>
        )
    }
}

export default ClinicEmployees;



// WEBPACK FOOTER //
// ./src/panels/ClinicEmployees.js